export default "__VITE_ASSET__C8q_rHIA__"